import React from "react";
import { Link } from "react-router-dom";

export const LEGAL_LINKS = [
  { to: "/a-propos", label: "À propos" },
  { to: "/tarifs", label: "Tarifs" },
  { to: "/paiements", label: "Paiements" },
  { to: "/remboursement", label: "Remboursement" },
  { to: "/cgu", label: "Conditions d'utilisation" },
  { to: "/confidentialite", label: "Confidentialité" },
  { to: "/contact", label: "Contact" },
];

export const LegalFooter = ({ className = "" }) => (
  <footer className={`text-[11px] text-muted-foreground ${className}`} data-testid="legal-footer">
    <nav className="flex flex-wrap justify-center gap-x-3 gap-y-1">
      {LEGAL_LINKS.map((l) => (
        <Link key={l.to} to={l.to} className="hover:text-foreground underline-offset-2 hover:underline" data-testid={`footer-link-${l.to.slice(1)}`}>{l.label}</Link>
      ))}
    </nav>
    <p className="text-center mt-2">© {new Date().getFullYear()} MIHOD PAY — Paiements sécurisés par Stripe.</p>
  </footer>
);

export default LegalFooter;
